import { createSlice } from '@reduxjs/toolkit';

import { handleGetMedicationDetails } from './actions';
import { IMedicationDetailsState } from './slice.interface';

const initialState: IMedicationDetailsState = {
  data: null,
  activeId: null,
  isLoading: false,
  error: false,
};

export const medicationDetails = createSlice({
  name: 'medication-details',
  initialState,
  reducers: {
    removeGetMedicationDetails: state => {
      state.activeId = null;
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetMedicationDetails.pending, (state: IMedicationDetailsState, action) => {
        state.activeId = action.meta.arg;
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetMedicationDetails.rejected, (state: IMedicationDetailsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetMedicationDetails.fulfilled, (state: IMedicationDetailsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
      });
  },
});

export const { removeGetMedicationDetails } = medicationDetails.actions;

export default medicationDetails.reducer;
